import styled from '../../theme';
import GeoSuggest from 'react-geosuggest';

export const StyledCityGeoSuggest = styled(GeoSuggest).attrs({
  className: 'cityInput'
})`
  &.cityInput {
    background: white;
    width: 100%;
    height: 75%;
    border: 1px solid #CCC;
    display: block;
    font-size: 0.9em;
    font-weight: 400;
    border-radius: 5px;
    background: #fff;
    box-sizing: border-box;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 0.75em 0;
    -webkit-appearance: none;
    border: none;

    &.hasContent + label {
        font-size: 0.7em;
        top: 10px;
    }
        
    &.error {
        outline: none;
        box-shadow: 0 0 2px 2px red;
    }
        
    &.error + label {
        color: red;
    }
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    &[type="number"] {
        -moz-appearance: textfield;
    }
    &:focus {
      outline: none;
      box-shadow: 0 0 2px 2px ${(props: any) => props.theme.colors.backgroundHighlight};
    }
      .geosuggest__input {
        box-shadow: none;
        padding-top: 8px;
        padding-right: 0px;
        border-right: 0px;
        width: 94%
          &:focus {
            outline: none;
            border-bottom-color: white;
            border-top-color: white;
            border-left-color: white;
            border-right-color: white;
          }
      }
      .hasContent {
        outline: none;
        padding-top: 18px;
        padding-bottom: 0px;
    }
  }

  }
`



// WEBPACK FOOTER //
// ./src/components/Inputs/CityInput.tsx